/**
 * Register modal wiring — Phase 3.11.
 *
 *   - "Registering for a group" checkbox toggles the GroupName field row.
 *   - Google reCAPTCHA v2 callbacks (`onRegisterRecaptchaSuccess` /
 *     `onRegisterRecaptchaExpired`) bind via `window` because the reCAPTCHA
 *     script invokes them by name from global scope. They drop the token into
 *     the hidden `#js-register-recaptcha-token` input and enable / disable the
 *     submit button. The submit button starts disabled so users can't post
 *     without solving the challenge.
 *   - Auto-reopens the register modal when TempData["RegisterError"] is
 *     populated on first paint (same UX as the Login modal's auto-reopen).
 */

const RECAPTCHA_TOKEN_INPUT_ID = 'js-register-recaptcha-token';
const SUBMIT_BUTTON_ID = 'js-register-submit';
const GROUP_TOGGLE_ID = 'js-register-group-toggle';
const GROUP_NAME_ROW_ID = 'js-register-group-name-row';

declare global {
    interface Window {
        onRegisterRecaptchaSuccess?: (token: string) => void;
        onRegisterRecaptchaExpired?: () => void;
    }
}

function setRecaptchaToken(token: string): void {
    const input = document.getElementById(RECAPTCHA_TOKEN_INPUT_ID) as HTMLInputElement | null;
    if (input) {
        input.value = token;
    }
}

function setSubmitEnabled(enabled: boolean): void {
    const btn = document.getElementById(SUBMIT_BUTTON_ID) as HTMLButtonElement | null;
    if (btn) {
        btn.disabled = !enabled;
    }
}

function wireGroupToggle(): void {
    const toggle = document.getElementById(GROUP_TOGGLE_ID) as HTMLInputElement | null;
    const row = document.getElementById(GROUP_NAME_ROW_ID) as HTMLElement | null;
    if (!toggle || !row) {
        return;
    }

    const sync = (): void => {
        row.style.display = toggle.checked ? '' : 'none';
    };
    toggle.addEventListener('change', sync);
    sync();
}

function shouldAutoOpenRegister(): boolean {
    const errorEl = document.querySelector<HTMLElement>('#amri-modal-register .amri-form-error');
    return !!(errorEl && errorEl.textContent && errorEl.textContent.trim().length > 0);
}

export function initRegisterModal(): void {
    window.onRegisterRecaptchaSuccess = (token: string): void => {
        setRecaptchaToken(token);
        setSubmitEnabled(true);
    };
    window.onRegisterRecaptchaExpired = (): void => {
        setRecaptchaToken('');
        setSubmitEnabled(false);
    };

    wireGroupToggle();

    if (shouldAutoOpenRegister()) {
        const modal = document.getElementById('amri-modal-register');
        if (modal) {
            modal.style.display = 'block';
            document.body.classList.add('amri-modal-open');
        }
    }
}
